import {BruteForceSymbol, BruteForceSymbolStates} from "./BruteForceSymbol";
import {SimpleReelModelSymbolPosition} from "../../core/reel/simplereel/SimpleReelModel";
import {gsap} from "gsap";
import {BruteForceHelper} from "../utils/BruteForceHelper";
import {BruteForce} from "../BruteForce";
import {TimelineSprite} from "@nolimitcity/promo-panel/bin/utils/TimelineSprite";

export class BruteForceScatterSymbol extends BruteForceSymbol {
    private _scatterTease: TimelineSprite;
    private _isTeasePlaying: boolean;

    constructor(symbolName: string, symPos: SimpleReelModelSymbolPosition, symbolState: BruteForceSymbolStates) {
        super(symbolName, symPos, symbolState);
        this.addTeaseEffect();
        this._isTeasePlaying = false;
    }

    private addTeaseEffect(): void {
        this._scatterTease = new TimelineSprite(BruteForce.assetLoader.getTextures("scatterTease"));
        this._scatterTease.anchor.set(0.5, 0.5);
        this._scatterTease.position.y = -76;
        this._scatterTease.hide();

        this.addChild(this._scatterTease);
    }

    public showTeaseEffect(): void {
        (<TimelineSprite>this._scatterTease).show();
        this._scatterTease.playLoop();
        this._isTeasePlaying = true;
        this._scatterTease.alpha = 1;
        this._spine.scale.set(1.1, 1.1);
    }

    public stopTeaseEffect(): gsap.core.Timeline {
        const stopTeaseTl: gsap.core.Timeline = gsap.timeline();
        if (this._isTeasePlaying) {
            stopTeaseTl.to(this._scatterTease, {alpha: 0, duration: 0.1}, 0);
            stopTeaseTl.to(this._spine.scale, {x: 1, y: 1, duration: 0.1}, "<");
            stopTeaseTl.add(() => {
                this._scatterTease.hide();
                this._scatterTease.stopLoop();
            });
        }
        return stopTeaseTl;
    }


    public playAnimationOnLoop(animName: string, toLoop: boolean): void {
        this._spine.autoUpdate = toLoop;
        this._spine.state.setAnimation(0, animName, toLoop);

        //console.log(`in ${animName}`);
    }

}